require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-josephus-problem.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-josephus-problem");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-josephus-problem!./.cache/json/coding-interview-prep-rosetta-code-josephus-problem.json
// module id = 1909
// module chunks = 231608221292675